import BloomBarChart from './BloomBarChart';

export default BloomBarChart;
